import { render, staticRenderFns } from "./DisabledItemListGroup.vue?vue&type=template&id=4f166002"
import script from "./DisabledItemListGroup.vue?vue&type=script&lang=js"
export * from "./DisabledItemListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports